
























































































import { Component, Ref, Watch, Vue } from 'vue-property-decorator';
import {
  lbzfCancelContextmenu,
  lbzfChangeModeHandler,
  lbzfIsDarkModeEnabled,
  lbzfIsMobileBreakpoint,
  lbzfSetModeAttributes,
  lbzfSupportsCssVariables
} from '@/utils/funcs';

@Component
export default class App extends Vue {
  @Ref('drawer') private rdrawer!: HTMLFormElement;

  private NAV: object = {
    components: [
      {
        path: '/components/backdrop',
        label: 'Backdrop'
      },
      {
        path: '/components/button',
        label: 'Button'
      },
      {
        path: '/components/card',
        label: 'Card'
      },
      {
        path: '/components/checkbox',
        label: 'Checkbox'
      },
      {
        path: '/components/dialog',
        label: 'Dialog'
      },
      {
        path: '/components/divider',
        label: 'Divider'
      },
      {
        path: '/components/drawer',
        label: 'Drawer'
      },
      {
        path: '/components/empty-state',
        label: 'Empty state'
      },
      {
        path: '/components/fab',
        label: 'FAB (floating action button)'
      },
      {
        path: '/components/icon',
        label: 'Icon'
      },
      {
        path: '/components/icon-button',
        label: 'Icon button'
      },
      {
        path: '/components/list',
        label: 'List'
      },
      {
        path: '/components/radio',
        label: 'Radio'
      },
      {
        path: '/components/snackbar',
        label: 'Snackbar'
      },
      {
        path: '/components/state',
        label: 'State'
      },
      {
        path: '/components/switch',
        label: 'Switch'
      },
      {
        path: '/components/tab',
        label: 'Tab'
      },
      {
        path: '/components/top-app-bar',
        label: 'Top app bar'
      }
    ],
    utilities: [
      {
        path: '/utilities/aspect-ratio',
        label: 'Aspect ratio'
      },
      {
        path: '/utilities/clearfix',
        label: 'Clearfix'
      },
      {
        path: '/utilities/elevation',
        label: 'Elevation'
      },
      {
        path: '/utilities/layout-grid',
        label: 'Layout grid'
      },
      {
        path: '/utilities/surface',
        label: 'Surface'
      },
      {
        path: '/utilities/truncate',
        label: 'Truncate'
      },
      {
        path: '/utilities/typography',
        label: 'Typography'
      }
    ],
    links: [
      {
        path: 'https://github.com/lbzui/vue',
        label: 'GitHub repo'
      },
      {
        path: 'https://github.com/lbzui/vue/projects/2',
        label: 'API documentation'
      },
      {
        path: 'https://material.io/',
        label: 'Material Design'
      },
      {
        path: 'https://material.io/resources/color/',
        label: 'Material Color Tool'
      },
      {
        path: 'https://material.io/resources/icons/',
        label: 'Material Icons'
      }
    ]
  };

  private vactive = !lbzfIsMobileBreakpoint();
  private vsupportsCssVars: boolean = lbzfSupportsCssVariables();
  private visDark = false;

  @Watch('$route.name')
  private frouteChanged(): void {
    if (this.rdrawer.visMobile) {
      this.rdrawer.fclose();
    }
  }

  private created(): void {
    lbzfCancelContextmenu();

    if (this.vsupportsCssVars) {
      this.fchangeMode();
      lbzfChangeModeHandler(this.fchangeMode);
    }
  }

  private freload(): void {
    window.location.reload();
  }

  private fchangeMode(): void {
    const isDark: boolean = lbzfIsDarkModeEnabled();

    this.visDark = isDark;
    this.fsetTheme(isDark);
  }

  private fsetTheme(val: boolean, e?: MouseEvent): void {
    lbzfSetModeAttributes(val, {
      light: '#3700b3',
      dark: '#000'
    });

    if (val && !e) {
      this.$lbzSnackbar('Dark Mode is enabled on your device.');
    }
  }
}
